import SEOHead from '@/components/SEOHead';
import LegalDocument from '@/components/LegalDocument';

const content = {
  'zh-TW': {
    title: '私隱政策',
    updated: '最後更新日期：2026 年 10 月',
    intro: '埵智有限公司（DZent Limited，以下簡稱「本公司」、「我們」）尊重並致力於保護您的個人私隱。本私隱政策說明當您瀏覽本網站（dzentlimited.com）及使用我們的服務時，我們如何收集、使用、儲存及保護您的個人資料。請在使用本網站前仔細閱讀本政策。',
    sections: [
      {
        heading: '1. 我們是誰',
        paragraphs: [
          '埵智有限公司（DZent Limited）是一間於香港註冊成立的有限公司，開發及營運用於合約與貿易單據風險核對的 AI 軟件，包括 LC Shield（getlcshield.com）及 Vowpace AI（vowpace.com）。本政策僅適用於 dzentlimited.com；各產品設有其自身的私隱政策。如對本政策有任何疑問，可透過電郵 info@dzentlimited.com 與我們聯絡。',
        ],
      },
      {
        heading: '2. 我們收集的資料',
        paragraphs: ['當您使用本網站時，我們可能收集以下類別的資料：'],
        items: [
          '聯絡表格資料：當您透過「聯繫我們」頁面提交表格時，我們會收集您提供的姓名、電郵地址及留言內容。',
          '語言偏好：我們使用瀏覽器本地儲存（localStorage）記錄您選擇的網站語言，以便下次瀏覽時保留您的偏好。',
          '技術資料：與一般網站相同，伺服器可能記錄基本的存取資訊（如 IP 位址、瀏覽器類型），用於保安及維護用途。',
        ],
      },
      {
        heading: '3. 資料的使用方式',
        paragraphs: ['我們收集的資料僅用於以下用途：'],
        items: [
          '回覆您透過聯絡表格提出的查詢或合作意向；',
          '改善本網站的內容、功能及用戶體驗；',
          '遵守適用的法律及監管要求。',
        ],
      },
      {
        heading: '4. 資料儲存與保安',
        paragraphs: [
          '您透過聯絡表格提交的資料會以加密連線（HTTPS）傳送，並儲存於受保護的資料庫中。我們採取合理的技術及管理措施防止資料遭未經授權的存取、披露、修改或銷毀。我們只會在達成收集目的所需的合理期間內保留您的資料。',
        ],
      },
      {
        heading: '5. 資料披露與第三方',
        paragraphs: [
          '我們不會出售或出租您的個人資料。服務供應商（網站寄存／CDN、分析、字型）會代表我們處理技術性資料。',
        ],
      },
      {
        heading: '6. Cookie 與本地儲存',
        paragraphs: [
          '本網站使用瀏覽器本地儲存（localStorage）保存您的語言偏好。本網站使用 PostHog（PostHog Cloud，美國）進行分析，其會設置第一方 Cookie 或本地儲存項目，並可能對部分瀏覽工作階段進行抽樣記錄；Cloudflare 可能設置安全相關 Cookie；Google Fonts 字型可能從 Google 伺服器載入。您可隨時透過瀏覽器設定清除 Cookie 及本地儲存資料。',
        ],
      },
      {
        heading: '7. 您的權利',
        paragraphs: [
          '根據香港《個人資料（私隱）條例》（第 486 章），您有權查閱及更正我們持有的您的個人資料。如欲行使上述權利，或要求刪除您的資料，請電郵至 info@dzentlimited.com，我們會在合理時間內處理您的要求。',
        ],
      },
      {
        heading: '8. 兒童私隱',
        paragraphs: [
          '本網站並非以未滿 13 歲的兒童為對象。我們不會在知情的情況下收集兒童的個人資料。如您認為我們可能持有兒童的資料，請與我們聯絡，我們會盡快刪除。',
        ],
      },
      {
        heading: '9. 政策的修訂',
        paragraphs: [
          '我們可能不時修訂本私隱政策。任何修訂將於本頁面公佈並即時生效。建議您定期查閱本頁面以了解最新內容。',
        ],
      },
      {
        heading: '10. 聯絡我們',
        paragraphs: [
          '如對本私隱政策或我們處理個人資料的方式有任何疑問或意見，歡迎電郵至 info@dzentlimited.com 與我們聯絡。',
        ],
      },
    ],
  },
  'zh-CN': {
    title: '隐私政策',
    updated: '最后更新日期：2026 年 10 月',
    intro: '埵智有限公司（DZent Limited，以下简称「本公司」、「我们」）尊重并致力于保护您的个人隐私。本隐私政策说明当您浏览本网站（dzentlimited.com）及使用我们的服务时，我们如何收集、使用、储存及保护您的个人资料。请在使用本网站前仔细阅读本政策。',
    sections: [
      {
        heading: '1. 我们是谁',
        paragraphs: [
          '埵智有限公司（DZent Limited）是一间于香港注册成立的有限公司，开发及运营用于合同与贸易单据风险核对的 AI 软件，包括 LC Shield（getlcshield.com）及 Vowpace AI（vowpace.com）。本政策仅适用于 dzentlimited.com；各产品设有其自身的隐私政策。如对本政策有任何疑问，可通过电邮 info@dzentlimited.com 与我们联系。',
        ],
      },
      {
        heading: '2. 我们收集的资料',
        paragraphs: ['当您使用本网站时，我们可能收集以下类别的资料：'],
        items: [
          '联系表格资料：当您通过「联系我们」页面提交表格时，我们会收集您提供的姓名、电邮地址及留言内容。',
          '语言偏好：我们使用浏览器本地储存（localStorage）记录您选择的网站语言，以便下次浏览时保留您的偏好。',
          '技术资料：与一般网站相同，服务器可能记录基本的访问信息（如 IP 地址、浏览器类型），用于安全及维护用途。',
        ],
      },
      {
        heading: '3. 资料的使用方式',
        paragraphs: ['我们收集的资料仅用于以下用途：'],
        items: [
          '回复您通过联系表格提出的查询或合作意向；',
          '改善本网站的内容、功能及用户体验；',
          '遵守适用的法律及监管要求。',
        ],
      },
      {
        heading: '4. 资料储存与安全',
        paragraphs: [
          '您通过联系表格提交的资料会以加密连接（HTTPS）传送，并储存于受保护的数据库中。我们采取合理的技术及管理措施防止资料遭未经授权的访问、披露、修改或销毁。我们只会在达成收集目的所需的合理期间内保留您的资料。',
        ],
      },
      {
        heading: '5. 资料披露与第三方',
        paragraphs: [
          '我们不会出售或出租您的个人资料。服务提供商（网站托管／CDN、分析、字体）会代表我们处理技术性资料。',
        ],
      },
      {
        heading: '6. Cookie 与本地储存',
        paragraphs: [
          '本网站使用浏览器本地储存（localStorage）保存您的语言偏好。本网站使用 PostHog（PostHog Cloud，美国）进行分析，其会设置第一方 Cookie 或本地储存条目，并可能对部分浏览会话进行抽样记录；Cloudflare 可能设置安全相关 Cookie；Google Fonts 字体可能从 Google 服务器加载。您可随时通过浏览器设定清除 Cookie 及本地储存资料。',
        ],
      },
      {
        heading: '7. 您的权利',
        paragraphs: [
          '根据香港《个人资料（私隐）条例》（第 486 章），您有权查阅及更正我们持有的您的个人资料。如欲行使上述权利，或要求删除您的资料，请电邮至 info@dzentlimited.com，我们会在合理时间内处理您的要求。',
        ],
      },
      {
        heading: '8. 儿童隐私',
        paragraphs: [
          '本网站并非以未满 13 岁的儿童为对象。我们不会在知情的情况下收集儿童的个人资料。如您认为我们可能持有儿童的资料，请与我们联系，我们会尽快删除。',
        ],
      },
      {
        heading: '9. 政策的修订',
        paragraphs: [
          '我们可能不时修订本隐私政策。任何修订将于本页面公布并即时生效。建议您定期查阅本页面以了解最新内容。',
        ],
      },
      {
        heading: '10. 联系我们',
        paragraphs: [
          '如对本隐私政策或我们处理个人资料的方式有任何疑问或意见，欢迎电邮至 info@dzentlimited.com 与我们联系。',
        ],
      },
    ],
  },
  en: {
    title: 'Privacy Policy',
    updated: 'Last updated: October 2026',
    intro: 'DZent Limited ("the Company", "we", "us") respects and is committed to protecting your personal privacy. This Privacy Policy explains how we collect, use, store, and protect your personal data when you visit this website (dzentlimited.com) and use our services. Please read this policy carefully before using this website.',
    sections: [
      {
        heading: '1. Who We Are',
        paragraphs: [
          'DZent Limited is a Hong Kong-incorporated company that develops and operates AI software for contract and trade-document risk checking, including LC Shield (getlcshield.com) and Vowpace AI (vowpace.com). This policy covers dzentlimited.com only; each product has its own privacy policy. If you have any questions about this policy, you may contact us at info@dzentlimited.com.',
        ],
      },
      {
        heading: '2. Data We Collect',
        paragraphs: ['When you use this website, we may collect the following categories of data:'],
        items: [
          'Contact form data: When you submit the form on our "Contact Us" page, we collect the name, email address, and message you provide.',
          'Language preference: We use browser local storage (localStorage) to remember your selected website language for future visits.',
          'Technical data: As with most websites, our servers may log basic access information (such as IP address and browser type) for security and maintenance purposes.',
        ],
      },
      {
        heading: '3. How We Use Your Data',
        paragraphs: ['The data we collect is used solely for the following purposes:'],
        items: [
          'Responding to inquiries or partnership requests submitted through the contact form;',
          'Improving the content, functionality, and user experience of this website;',
          'Complying with applicable legal and regulatory requirements.',
        ],
      },
      {
        heading: '4. Data Storage and Security',
        paragraphs: [
          'Data submitted through the contact form is transmitted over an encrypted connection (HTTPS) and stored in a protected database. We take reasonable technical and organizational measures to prevent unauthorized access, disclosure, alteration, or destruction of your data. We retain your data only for as long as reasonably necessary to fulfill the purposes for which it was collected.',
        ],
      },
      {
        heading: '5. Disclosure and Third Parties',
        paragraphs: [
          'We do not sell or rent your personal data. Service providers (hosting/CDN, analytics, fonts) process technical data on our behalf.',
        ],
      },
      {
        heading: '6. Cookies and Local Storage',
        paragraphs: [
          'This website stores your language preference in browser local storage. It uses PostHog (PostHog Cloud, United States) for analytics, which sets a first-party cookie or local-storage entry and may record a sample of sessions; Cloudflare may set security cookies; Google Fonts may be loaded from Google servers. You can clear cookies and local storage in your browser settings.',
        ],
      },
      {
        heading: '7. Your Rights',
        paragraphs: [
          'Under the Hong Kong Personal Data (Privacy) Ordinance (Cap. 486), you have the right to access and correct the personal data we hold about you. To exercise these rights or request deletion of your data, please email info@dzentlimited.com and we will process your request within a reasonable time.',
        ],
      },
      {
        heading: "8. Children's Privacy",
        paragraphs: [
          'This website is not directed at children under the age of 13. We do not knowingly collect personal data from children. If you believe we may hold data relating to a child, please contact us and we will delete it promptly.',
        ],
      },
      {
        heading: '9. Changes to This Policy',
        paragraphs: [
          'We may revise this Privacy Policy from time to time. Any changes will be posted on this page and take effect immediately. We encourage you to review this page periodically for the latest information.',
        ],
      },
      {
        heading: '10. Contact Us',
        paragraphs: [
          'If you have any questions or comments about this Privacy Policy or how we handle personal data, please contact us at info@dzentlimited.com.',
        ],
      },
    ],
  },
};

export default function PrivacyPolicyPage() {
  return (
    <>
      <SEOHead path="/privacy" />
      <LegalDocument content={content} testId="privacy-page" />
    </>
  );
}
